
function App() {
  return (
    <div>
      <h1>Spotify</h1>
    </div>
  );
}

export default App;
